import React from "react";

interface IProps {
  name: string;
  description?: string;
  imageUrl?: string;
  url: string;
  price?: number;
  priceCurrency?: string;
  ratingValue?: number;
  ratingCount?: number;
}

const ProductSchema = ({
  name,
  description,
  imageUrl,
  url,
  price,
  priceCurrency = "USD",
  ratingValue,
  ratingCount,
}: IProps) => {
  const schema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    url,
    brand: {
      "@type": "Brand",
      name: "OTTO Motors",
    },
  };

  if (description) {
    schema.description = description;
  }

  if (imageUrl) {
    schema.image = imageUrl;
  }

  if (price) {
    schema.offers = {
      "@type": "Offer",
      price: String(price),
      priceCurrency,
      availability: "https://schema.org/InStock",
      url,
    };
  }

  if (ratingValue) {
    schema.aggregateRating = {
      "@type": "AggregateRating",
      ratingValue: String(ratingValue),
      bestRating: "5",
      ...(ratingCount && { ratingCount: String(ratingCount) }),
    };
  }

  return (
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  );
};

export default ProductSchema;
